import React from 'react';
import { useMergedRefs } from '../hooks/useMergedRefs.js';
import { Box } from './Box.js';
import { useOverflow } from '../hooks/useOverflow.js';
import { useSafeContext } from '../hooks/useSafeContext.js';
let OverflowContainerComponent = React.forwardRef((props, ref) => {
  let { itemsCount, children, overflowOrientation, ...rest } = props;
  let [containerRef, visibleCount] = useOverflow(
    itemsCount,
    false,
    overflowOrientation,
  );
  let overflowContainerContextValue = React.useMemo(
    () => ({
      visibleCount,
      itemsCount,
    }),
    [itemsCount, visibleCount],
  );
  return React.createElement(
    OverflowContainerContext.Provider,
    {
      value: overflowContainerContextValue,
    },
    React.createElement(
      Box,
      {
        ref: useMergedRefs(ref, containerRef),
        ...rest,
      },
      children,
    ),
  );
});
let OverflowContainerOverflowNode = (props) => {
  let { children } = props;
  let { visibleCount, itemsCount } = useOverflowContainerContext();
  let isOverflowing = visibleCount < itemsCount;
  return isOverflowing ? children : null;
};
export const OverflowContainer = Object.assign(OverflowContainerComponent, {
  OverflowNode: OverflowContainerOverflowNode,
  useContext: useOverflowContainerContext,
});
let OverflowContainerContext = React.createContext(void 0);
function useOverflowContainerContext() {
  let overflowContainerContext = useSafeContext(OverflowContainerContext);
  return overflowContainerContext;
}
